import React, { useEffect, useState } from 'react';
import { Grid, Box, Paper, Typography, Button, CircularProgress } from '@material-ui/core';
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RialSeparator } from '../../../utils/price-separator';
import { billPaymentApi } from "../../../services/api/bill"

const BillPayment = () => {
    // --------- states
    const [loading, setLoading] = useState(false)
    //---------- end states

    // --------- variables
    const classes = useStyles();
    const { info } = useSelector(({ payment }: any) => payment)
    const history = useHistory()
    // --------- end variables

    // --------- useEffects
    useEffect(() => {
        if (!info) {
            history.push("/")
        }
    }, [])
    // --------- end useEffects

    // --------- functions
    const handleSubmit = async () => {
        setLoading(true)
        const res = await billPaymentApi({
            bill_code: info.bill_code,
            pay_id: info.payment_code,
            amount: info.payment_code,
            add_to_my_bill: false
        })
        if (res) {
            window.open(res.ipg_url, "_self")
        }
        setLoading(false)
    }
    // --------- end functions
    return (
        <>
            <Grid container justifyContent="center">
                <Grid
                    item
                    className={classes.responsiveBreak}
                    xs={12}
                    md={6}
                    lg={5}
                >
                    {/* @ts-ignore */}
                    <Box className="dir box mainBox p-res m-bill">
                        <Typography style={{ textAlign: 'center' }}>{info?.bill_type_title}</Typography>
                        <Paper className="text-center paper mt-3">
                            {/* @ts-ignore */}
                            <Box display={"flex"} justifyContent={'space-between'} px={3}>
                                <span>شناسه قبض :</span>
                                <span>{info?.bill_code}</span>
                            </Box>
                        </Paper>
                        <Paper className="text-center paper mt-3">
                            {/* @ts-ignore */}
                            <Box display={"flex"} justifyContent={'space-between'} px={3}>
                                <span>نام صاحب حساب :</span>
                                <span>{info?.full_name}</span>
                            </Box>
                        </Paper>
                        <Paper className="text-center paper mt-3">
                            {/* @ts-ignore */}
                            <Box display={"flex"} justifyContent={'space-between'} px={3}>
                                <span>مبلغ :</span>
                                <span>{RialSeparator(info?.amount)}</span>
                            </Box>
                        </Paper>
                        <Grid container spacing={2}>
                            <Grid item xs={8}>
                                {/* @ts-ignore */}
                                <Box>
                                    <Button
                                        variant="contained"
                                        className="success mt-4"
                                        onClick={handleSubmit}
                                        disabled={loading ? true : false}
                                    >
                                        {loading ? <CircularProgress color="inherit" style={{ width: '20px', height: '20px', marginBottom: '-6px' }} /> : "پرداخت"}
                                    </Button>
                                </Box>
                            </Grid>
                            <Grid item xs={4}>
                                {/* @ts-ignore */}
                                <Box>
                                    <Button
                                        variant="contained"
                                        className="back endBtn mt-4"
                                        onClick={() => { history.push('/') }}
                                    >
                                        بازگشت
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>

        </>
    );
};

export default BillPayment;

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        responsiveBreak: {
            [theme.breakpoints.only("md")]: {},
        },

    })
);

